module.exports = __webpack_public_path__ + "static/media/blog.efdb1538.svg";